<script lang="ts">
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getProjectReportOptimisationContext} from '../../project-report-optimisation-context';
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {fly} from 'svelte/transition';
    import ReportOptimisationUsersTable from './ReportOptimisationUsersTable.svelte';
    import ReportOptimisationUsersUserDetail from './ReportOptimisationUsersUserDetail.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import {ErpTwoSplitLayout} from 'src/features/erp/components';

    export let optimisedBusinessItemRecord: RecordRow;

    const context = getProjectReportOptimisationContext();

    let openedUserReportRecord: RecordRow | null;
    const openedUserUnsubscribe = context.openedUser$.subscribe((currentOpenedUser) => openedUserReportRecord = currentOpenedUser);

    onDestroy(() => {
        openedUserUnsubscribe();
    });
</script>

<ErpTwoSplitLayout orientation="horizontal"
                   pageClass="sutor-reports-optimisation-users-page"
                   resizeDisabled>

    <svelte:fragment slot="first-panel">
        <ReportOptimisationUsersTable {optimisedBusinessItemRecord}/>
    </svelte:fragment>

    <svelte:fragment slot="second-panel">
        {#key openedUserReportRecord}
            <div class="optimisation-user-detail"
                 class:no-user-report={!exists(openedUserReportRecord)}
                 in:fly={{y: 10, duration: 250}}>

                {#if !exists(openedUserReportRecord)}
                    <IconedContent align="center" justify="center" orientation="vertical" icon="info">
                        <span class="text-muted">Zde budou zobrazeny podrobnosti výkazu po rozkliknutí</span>
                    </IconedContent>
                {:else}
                    <ReportOptimisationUsersUserDetail reportRecord={openedUserReportRecord} {optimisedBusinessItemRecord}/>
                {/if}
            </div>
        {/key}
    </svelte:fragment>
</ErpTwoSplitLayout>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .optimisation-user-detail {
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;

        &.no-user-report {
            align-items: center;
            justify-content: center;
        }
    }
</style>